import { render, staticRenderFns } from "./CommonPhrasesModal.vue?vue&type=template&id=f7929592&scoped=true&"
import script from "./CommonPhrasesModal.vue?vue&type=script&lang=js&"
export * from "./CommonPhrasesModal.vue?vue&type=script&lang=js&"
import style0 from "./CommonPhrasesModal.vue?vue&type=style&index=0&id=f7929592&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7929592",
  null
  
)

export default component.exports